/**
 * Dashboard-specific type definitions for the logged-in homepage states.
 * These map the platform's real data structures to the shapes needed by the
 * four dashboard state components.
 */

export interface DashboardCourse {
  id: string;
  title: string;
  emoji: string;
  durationMin: number;
  isFree: boolean;
  category: string;
}

export interface DashboardEnrolledCourse extends DashboardCourse {
  progressPct: number;
}

export interface DashboardCompletedCourse extends DashboardCourse {
  completedAt: string;
  xpEarned: number;
}

export interface DashboardUser {
  name: string;
  plan: 'free' | 'premium';
  assessmentCompleted: boolean;
  assessmentResults?: {
    role: string;
    experience: string;
    topGoal: string;
    weeklyTime: string;
    matchedCourses: DashboardCourse[];
  };
  enrolledCourses: DashboardEnrolledCourse[];
  completedCourses: DashboardCompletedCourse[];
  xp: number;
  streakDays: number;
  aiReadinessLevel: string;
  aiReadinessPct: number;
  weeklyXP: number[];
  completedLessonToday: boolean;
}

export type DashboardState = 1 | 2 | 3 | 4;

export function getDashboardState(user: DashboardUser): DashboardState {
  if (user.plan === 'premium') return 4;
  if (!user.assessmentCompleted) return 1;
  if (user.completedCourses.length === 0) return 2;
  return 3;
}
